import React, { FC } from 'react'
import "../css/dynamicCard.css"
import "../css/dynamicCardSt.css"

interface DynamicCardProps {
  iconSrc?: string;
  iconAlt?: string;
  title?: string;
  paragraph?: string;
  borderLeft?: boolean;
  borderRight?: boolean;
}

const DynamicCard:FC<DynamicCardProps> = ({
  iconSrc,
  iconAlt,
  title,
  paragraph,
  borderLeft,
  borderRight
}) => {

  const isPng = typeof iconSrc === 'string' && iconSrc.toLowerCase().endsWith('.png')

  return (
    <article className={`scl--dca-con-bo-str ${borderLeft === true ? "border-left" : ""} ${borderRight === true ? "border-right" : ""}`}>
      <div className='scl--dcbs-st-con-str'>
        <div className={`scl--dscs-con-ico-str${isPng ? ' scl--dscs-con-ico-str--png' : ''}`}>
          <img src={iconSrc} alt={iconAlt} />
        </div>

        <div className='scl--dcbs-con-met-st-str'>
          <h6>{title}</h6>
          <p>{paragraph}</p>
        </div>

      </div>
    </article>
  )
}

export default DynamicCard